import React from 'react';
import PoolsSections from '../../components/ufo/pools/Index';  // ✅ Fix import

const PoolsPage = () => {
  return (
    <>
      <PoolsSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default PoolsPage;